import { withStyles } from '@material-ui/core';
import React, { ComponentType } from 'react';
import { CellProps } from 'react-table';
import { useBoolean } from 'react-use-boolean';
import { Button } from '../Button';
import { Dialog } from '../Dialog';
import { TableColumn } from './types';

export type ModalCell<
  Data extends Record<string, any>,
  Key extends Data[keyof Data],
> = ComponentType<CellProps<Data, Key> & { onClose: () => void }>;

type Options<Data extends Record<string, any>> = TableColumn<Data> & {
  ModalCell: ModalCell<Data, any>;
};

const CustomButton = withStyles({ root: { whiteSpace: 'nowrap', height: '44px' } })(Button);

export const makeOpenModalColumn = <Data extends Record<string, any>>(
  buttonLabel: string,
  { ModalCell, ...options }: Options<Data>,
): TableColumn<Data> => {
  return {
    ...options,
    Cell: (props: CellProps<Data>) => {
      const [open, actions] = useBoolean();
      return (
        <>
          <CustomButton variant='outlined' onClick={actions.on}>
            {buttonLabel}
          </CustomButton>
          <Dialog open={open} onClose={actions.off}>
            <ModalCell {...props} onClose={actions.off} />
          </Dialog>
        </>
      );
    },
  };
};
